import React from 'react';
import Spinner from '../Spinner';

function ApiResult({ loading, error, data, children, render = children }) {
  if (error) {
    return <p>Error: {error.response && error.response.data && error.response.data.message}</p>;
  }

  if (loading) {
    return (
      <div className="text-center">
        <Spinner />
      </div>
    );
  }

  return render(data);
}

export default ApiResult;